import { render, staticRenderFns } from "./warehouseBoard.vue?vue&type=template&id=4fb555d7&scoped=true&"
import script from "./warehouseBoard.vue?vue&type=script&lang=js&"
export * from "./warehouseBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb555d7",
  null
  
)

export default component.exports